import React, { Fragment, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import useForm from "react-hook-form";
import ButtonManagement from "form/components/button-management";
import { isEmpty, isNil } from "ramda";
import Success from "form/components/success";
import Error from "form/components/error";
import Header from "form/components/header";
import PersonalInfo from "form/components/personal-info";
import DateInfo from "form/components/date-info";
import CheckBoxField from "form/components/checkbox-field";
import {
  exists,
  getStructureFieldInfo,
  isFromGermany,
  enableSubmit,
} from "application/functions";
import ReactHtmlParser from "react-html-parser";
// import SelectAppointment from "./select-appointment/select-appointment";
import GermanComponent from "./german-component";
import SelectAppointment from "./select-appointment/select-appointment";

function Form(props) {
  const {
    structure,
    locale,
    showSuccess,
    showError,
    disableAfterSubmit,
    size,
    showDate,
    handleStore,
    showTime,
    availability,
    showTelephoneError,
    showEmailError,
    showMessageError,
    stlocId,
  } = props;

  const {
    register,
    handleSubmit,
    errors,
    setValue,
    watch,
    formState,
    setError,
  } = useForm();

  useEffect(() => {
    if (showTelephoneError) {
      setError("phone", {
        type: "manual",
        message: "phone error",
      });
    }

    if (showEmailError) {
      setError("email", {
        type: "manual",
        message: "mail error",
      });
    }
  }, [showTelephoneError, showEmailError]);

  const onSubmit = (data) => {
    props.submit(data);
  };

  const watchAllFields = watch();
  let anchorRef = null;
  let timeout = 0;

  const showForm = () => {
    return (
      !showSuccess &&
      !showError &&
      structure &&
      structure.iCanAnswer &&
      structure.status !== "EXPIRED"
    );
  };

  const showExpired = () => {
    return (
      !showSuccess &&
      !showError &&
      !isNil(structure) &&
      structure.status === "EXPIRED"
    );
  };

  const handleRef = (ref) => {
    if (ref !== null) {
      anchorRef = ref;
    }
  };

  const showAnswered = () => {
    return (
      !showSuccess &&
      !showError &&
      structure &&
      structure.status !== "EXPIRED" &&
      !structure.iCanAnswer
    );
  };

  const [height, setHeight] = useState(false);
  const [store, setStore] = useState(null);
  const [section, setSection] = useState(null);
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);
  const [covidPositive, setCovidPositive] = useState(false);

  const ref = useRef(null);

  useEffect(() => {
    setHeight(
      !isNil(ref.current) && ref.current.clientHeight > window.innerHeight
    );
  }, []);

  const aux = (name, value) => {
    if (name === "store") {
      setStore(value);
      setValue(name, value);
      setValue("section", "");
      setSection(null);
      setValue("day", "");
      setDate(null);
      setValue("time", "");
      setTime(null);
    }

    if (name === "section") {
      setSection(value);
      setValue(name, value);
      setValue("day", "");
      setDate(null);
      setValue("time", "");
      setTime(null);
    }

    if (name === "day") {
      setDate(value);
      setValue(name, value.toString());
      setValue("time", "");
      setTime(null);
    }

    if (name === "time") {
      setValue(name, value);
      setTime(value);
    }
  };

  const handleGermanChecks = (name) => {
    if (name === "covid_positive") {
      setCovidPositive(!covidPositive);
    }
  };

  return (
    <Fragment>
      {!(showError || showAnswered() || showExpired()) ? (
        <Fragment>
          {size !== "xs_vertical" && size !== "sm_vertical" && (
            <div ref={(ref) => handleRef(ref)} />
          )}
          <Header
            height={height}
            showSuccess={showSuccess}
            size={size}
            structure={structure}
          />
          <div className={`form__container`} ref={ref}>
            {showForm() && (
              <Fragment>
                <div className="row">
                  {(size === "xs_vertical" || size === "sm_vertical") && (
                    <div ref={(ref) => handleRef(ref)} />
                  )}
                  <form
                    onSubmit={handleSubmit(onSubmit)}
                    autoComplete="off"
                    className="form__form-component"
                  >
                    <div className="form__form-body">
                      <div
                        style={{
                          marginBottom: exists(
                            getStructureFieldInfo(
                              structure,
                              "info_time_visit",
                              "label"
                            )
                          )
                            ? "40px"
                            : "0px",
                        }}
                      >
                        {ReactHtmlParser(
                          getStructureFieldInfo(
                            structure,
                            "info_time_visit",
                            "label"
                          )
                        )}
                      </div>
                      <div className={"form__intro"}>
                        {ReactHtmlParser(
                          getStructureFieldInfo(structure, "intro", "label")
                        )}
                      </div>
                      <PersonalInfo
                        register={register}
                        errors={errors}
                        locale={locale}
                        isSubmitted={formState.isSubmitted}
                      />
                      <GermanComponent
                        register={register}
                        errors={errors}
                        locale={locale}
                        isSubmitted={formState.isSubmitted}
                        structure={structure}
                        handleGermanChecks={(name) => handleGermanChecks(name)}
                      />
                      {stlocId == null && (
                        <SelectAppointment
                          field="store"
                          register={register}
                          errors={errors}
                          locale={locale}
                          setSelectValue={(name, value) => {
                            handleStore(value);
                            aux(name, value);
                          }}
                          isSubmitted={formState.isSubmitted}
                          size={size}
                          required
                          show={true}
                          options={getStructureFieldInfo(
                            structure,
                            "store",
                            "options"
                          )}
                          value={store}
                        />
                      )}
                      <DateInfo
                        register={register}
                        errors={errors}
                        locale={locale}
                        setSelectValue={(name, value) => aux(name, value)}
                        size={size}
                        isSubmitted={formState.isSubmitted}
                        showDate={showDate}
                        showTime={showTime}
                        availability={availability}
                        date={date}
                        section={section}
                        time={time}
                        showByCountry={!isFromGermany() || covidPositive}
                      />
                      <CheckBoxField
                        register={register}
                        errors={errors}
                        locale={locale}
                        field="policies"
                        label={getStructureFieldInfo(
                          structure,
                          "legal_acceptation",
                          "label"
                        )}
                        required
                        isSubmitted={formState.isSubmitted}
                      />
                      {/* <div className={"form__disclaimer_info"}>
                        {ReactHtmlParser(
                          getStructureFieldInfo(
                            structure,
                            "disclaimer",
                            "label"
                          )
                        )}
                      </div> */}
                    </div>
                    {!isEmpty(showMessageError) && (
                      <div className="field-creator__labelfield--error">
                        {showMessageError}
                      </div>
                    )}
                    <ButtonManagement
                      locale={locale}
                      enableSubmit={enableSubmit(watchAllFields, availability)}
                      disableAfterSubmit={disableAfterSubmit}
                      height={height}
                      size={size}
                      literalButton={structure.literalButton || ""}
                    />
                  </form>
                </div>
              </Fragment>
            )}
            {showSuccess && <Success locale={locale} />}
          </div>
        </Fragment>
      ) : (
        <div className={`form__container-information`} ref={ref}>
          <Error
            size={size}
            locale={locale}
            showAnswered={showAnswered()}
            showExpired={showExpired()}
          />
        </div>
      )}
    </Fragment>
  );
}

Form.propTypes = {
  structure: PropTypes.object,
  submit: PropTypes.func,
  locale: PropTypes.string,
  showSuccess: PropTypes.bool,
  showError: PropTypes.bool,
  disableAfterSubmit: PropTypes.bool,
  size: PropTypes.string,
  showDate: PropTypes.bool,
  handleStore: PropTypes.func,
  showTime: PropTypes.bool,
  changeShowTime: PropTypes.func,
  availability: PropTypes.array,
  showTelephoneError: PropTypes.bool,
  showEmailError: PropTypes.bool,
  showMessageError: PropTypes.string,
  stlocId: PropTypes.string,
};

export default Form;
